export class CriticalInstrumentationCommon {
    id: number;
    equipment: string;
    internalId: string;
    procediment: string;
}

export class CriticalInstrumentation extends CriticalInstrumentationCommon {
}

export class CriticalInstrumentationExecution extends CriticalInstrumentationCommon {
    maker: string;
    model: string;
    serialNum: string;
    certificateNum: string;
    idCertificate: number;

    equipmentProtocol: string;
    procedimentProtocol: string;

    reasonChange: string;
    // Sin valor inicial quedaban en undefined al dar de alta, y JSON.stringify los omite del
    // payload: el alta llegaba al backend sin los dos campos. El resto de modelos de la
    // familia (equipment.ts, area.ts, roomAir.ts...) si los inicializan. Los valores son los
    // mismos que los de la columna en base.
    showDiffInDeviations = true;
    showDiffInObservations = false;

    fromProtocol = false;
}

// QLOD-95. Lo que decide el usuario al quitar de la ejecucion una instrumentacion que venia del
// protocolo: la razon y en que apartado del informe sale la frase de baja. Va al back en
// Execution.criticalInstrDeletions al guardar.
export class CriticalInstrumentationDeletion {
    id: number;
    reason: string;
    showDiffInDeviations = true;
    showDiffInObservations = false;
}
